import MockDate from 'mockdate'
import { isNil } from 'lodash'
import mockType from '@/constants/mockType'
import dayjs from '@/dayjs'

export const mock = {
    mocking() {
        return !!window.mock
    },
    type() {
        return window.mock?.type
    },
    screenshotting() {
        return this.mocking()
            && window.screenshotting
    },
    initialise() {
        if (!this.mocking()) {
            return
        }

        // Initialise date override if required
        const date = this.date()
        if (date !== null && date.isValid()) {
            MockDate.set(date.toDate())
        }
    },
    mockingSpace() {
        return this.type() === mockType.space
    },
    mockingDashboard() {
        return this.type() === mockType.dashboard
    },
    mockingModule() {
        return this.type() === mockType.module
    },
    mockingNews() {
        return this.type() === mockType.news
    },
    mockingMore() {
        return this.type() === mockType.more
    },
    mockingNotifications() {
        return this.type() === mockType.notifications
    },
    mockingIdentity() {
        return this.type() === mockType.identity
    },
    date() {
        const date = window.mock?.date
        if (isNil(date)) {
            return null
        }
        return dayjs(date)
    },
    content() {
        return window.mock?.content
    },
    version() {
        return window.mock?.version
    },
    dashboard() {
        return this.mockingDashboard()
            ? this.content().layout
            : {
                data: {
                    background_color: '#19424A',
                    background_image_file: null,
                    transparent_status_bar: false,
                },
                items: [],
            }
    },
}
